// Step1ProductName.tsx
import React from 'react';

interface Step1ProductNameProps {
  productName: string;
  setProductName: (name: string) => void;
  errors: { [key: string]: string };
}

const Step1ProductName: React.FC<Step1ProductNameProps> = ({ productName, setProductName, errors }) => {
  const maxLength = 15;
  const currentLength = productName.length;
  const isOverLimit = currentLength > maxLength;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      setProductName(value);
    } else {
      setProductName(value.slice(0, maxLength));
    }
  };

  return (
    <div className="w-full">
      {/* 상품명 */}
      <div className="mb-4">
        <label htmlFor="productName" className="block font-medium mb-1">
          상품명 <span className="text-red-500">*</span>
        </label>
        <p className="text-gray-500 text-sm mb-2 flex justify-between">
          <span>상품의 이름을 입력해주세요.</span>
          <span className={`text-sm ${isOverLimit ? 'text-red-500' : 'text-gray-500'}`}>
            [{currentLength}/{maxLength}]
          </span>
        </p>
        <input
          type="text"
          id="productName"
          className={`border p-2 w-full rounded ${
            errors.productName ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="상품명을 입력하세요"
          value={productName}
          onChange={handleChange}
        />
        {errors.productName && (
          <p className="text-red-500 text-sm mt-1">{errors.productName}</p>
        )}
      </div>
    </div>
  );
};

export default Step1ProductName;
